"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocketProvider = exports.SocketContext = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var SocketIO = _interopRequireWildcard(require("socket.io-client"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const SocketContext = /*#__PURE__*/_react.default.createContext({
  socket: null,
  connect: _args => null,
  disconnect: _args => null
});

exports.SocketContext = SocketContext;

const SocketProvider = ({
  children
}) => {
  const [socket, setSocket] = _react.default.useState(null);
  /**
   * @param path
   * @param token
   * @param username
   * @param port
   * @param ip
   *
   * @returns {Socket}
   */


  const connect = _react.default.useCallback(({
    path,
    token,
    username,
    port,
    ip
  }) => {
    // Ensure connection details are specified
    if (!path || !port || !ip) {
      console.error("Cannot start Terminal socket connection without url, port, and ip!");
      return null;
    } // Create new socket connection


    const newSocket = SocketIO.connect(path, {
      query: `token=${token}&username=${username}&port=${port}&ip=${ip}`,
      forceNew: true,
      reconnectionAttempts: 3,
      reconnectionDelay: 800,
      reconnectionDelayMax: 1500
    }); // Set socket state variable

    setSocket(newSocket);
    return newSocket;
  }, []);

  const disconnect = _react.default.useCallback(() => {
    if (!socket) return;
    socket.removeAllListeners();
    socket.disconnect();
    setSocket(null);
  }, [socket]);

  const contextValues = _react.default.useMemo(() => ({
    socket,
    connect,
    disconnect
  }), [socket, connect, disconnect]);

  return /*#__PURE__*/_react.default.createElement(SocketContext.Provider, {
    value: contextValues
  }, children);
};

exports.SocketProvider = SocketProvider;
SocketProvider.propTypes = {
  children: _propTypes.default.element.isRequired
};